import api from '../config/api';

export default class DiagnosisApi {
  static async getAll() {
      const response = await api.get(`/api/diagnoses`);
      return response.data;
  }
}